export const IWG_GROUP = 'IWG';
